import { type FC } from 'react';

import { opacityAnimation } from '@/common/config/motion-animations';
import { usePaymentStatus } from '@/common/hooks/payment-status';
import { type PaidSpecContractType } from '@/common/types/contract';
import { Confetti } from '@/components/Animations/Confetti/Confetti';
import { SecondaryButton } from '@/components/ui/Button/Button';
import { FullscreenOverlayWrapper } from '@/components/ui/FullscreenOverlayWrapper/FullscreenOverlayWrapper';
import PendingStatus from '@/components/ui/ViewStatusComponents/PendingStatus';
import SuccessfullStatus from '@/components/ui/ViewStatusComponents/SuccessfullStatus';
import { removeFullscreenModal } from '@/redux/reducers/modalsReducer';
import { selectContractById } from '@/redux/selectors/contractSelectors';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import { BuyProcess } from './BuyProcess/BuyProcess';
import { PlusContractGeneralInfo } from './PlusContractGeneralInfo/PlusContractGeneralInfo';

interface BuyPlusContractProps {
  contractId: string;
  className?: string;
}

const BuyPlusContract: FC<BuyPlusContractProps> = ({ contractId }) => {
  const dispatch = useAppDispatch();
  const paymentStatus = usePaymentStatus();
  const contract = useAppSelector((state) =>
    selectContractById(state, contractId),
  );

  const handleClose = (): void => {
    dispatch(removeFullscreenModal('buyPlusContract'));
  };

  return (
    !!contract && (
      <FullscreenOverlayWrapper
        {...opacityAnimation}
        className="px-6 pb-10 flex flex-col justify-between items-center"
      >
        {paymentStatus === 'success' && (
          <>
            <Confetti
              className="-z-[1] w-full h-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
              loop={false}
              autoPlay={true}
              speed={2}
              width="100%"
              height="100%"
            />
            <SuccessfullStatus handleClose={handleClose} className="w-full">
              <div className="flex flex-col items-center w-full">
                <PlusContractGeneralInfo
                  kind={contract.type as PaidSpecContractType}
                />
              </div>
            </SuccessfullStatus>
          </>
        )}
        {paymentStatus === 'pending' && (
          <>
            <PendingStatus />
            <SecondaryButton
              onClick={handleClose}
              text="Close"
              className="mt-3"
            />
          </>
        )}
        {!paymentStatus && <BuyProcess contract={contract} />}
      </FullscreenOverlayWrapper>
    )
  );
};

export { BuyPlusContract };
